import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Footer } from './Footer'
import { AdminEventPage } from './pages/AdminEventPage'
import { AdminEventsPage } from './pages/AdminEventsPage'
import { AdminUsersPage } from './pages/AdminUsersPage'
import { AdminProfilePage } from './pages/AdminProfilePage'
import { LoginPage } from './pages/LoginPage'
import { PublicEventPage } from './pages/PublicEventPage'
import { PublicStagePage } from './pages/PublicStagePage'
import { AdminLayout } from './layouts/AdminLayout'

export function App() {
  const { pathname } = useLocation()
  const isWide = pathname.startsWith('/admin') || pathname.startsWith('/e')
  return (
    <div className={`layout${isWide ? ' layout-wide' : ''}`}>
      <div className="layout-main">
        <Routes>
          <Route path="/" element={<Navigate to="/e" replace />} />
          <Route
            path="/e"
            element={
              <div className="card stack">
                <h1>PTCG 瑞士制觀賽</h1>
                <p className="muted">請使用活動連結或掃描 QR 進入。</p>
                <a href="/admin/login">後台登入</a>
              </div>
            }
          />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="events" replace />} />
            <Route path="events" element={<AdminEventsPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="profile" element={<AdminProfilePage />} />
          </Route>
          <Route path="/admin/events/:id" element={<AdminEventPage />} />
          <Route path="/e/:slug" element={<PublicEventPage />} />
          <Route path="/e/:slug/:stageId" element={<PublicStagePage />} />
          <Route path="*" element={<div className="card">找不到頁面</div>} />
        </Routes>
      </div>
      <Footer />
    </div>
  )
}
